import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Settings, X, Image, Users, UtensilsCrossed, Calendar, LogIn } from 'lucide-react';
import './AdminEditButton.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminEditButton = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const response = await axios.get(`${API}/auth/me`, {
        withCredentials: true
      });
      if (response.data.role === 'admin') {
        setIsAdmin(true);
      }
    } catch (err) {
      setIsAdmin(false);
    } finally {
      setLoading(false);
    }
  };

  const handleNavigate = (path) => {
    navigate(path);
    setIsOpen(false);
  };

  if (loading) return null;

  // Show login button if not admin
  if (!isAdmin) {
    return (
      <button 
        className="admin-login-btn"
        onClick={() => navigate('/team')}
        title="Admin Login"
      >
        <LogIn size={20} />
      </button>
    );
  }

  return (
    <div className="admin-edit-container">
      {/* Quick action menu */}
      {isOpen && (
        <div className="admin-quick-menu">
          <div className="quick-menu-header">
            <span>Quick Edit</span>
            <button onClick={() => setIsOpen(false)} className="close-btn">
              <X size={16} />
            </button>
          </div>
          <div className="quick-menu-items">
            <button onClick={() => handleNavigate('/admin?tab=content')}>
              <Image size={18} />
              <span>Gallery</span>
            </button>
            <button onClick={() => handleNavigate('/admin?tab=content')}>
              <Users size={18} />
              <span>Team</span>
            </button>
            <button onClick={() => handleNavigate('/admin?tab=content')}>
              <UtensilsCrossed size={18} />
              <span>Menu</span>
            </button>
            <button onClick={() => handleNavigate('/admin?tab=featured')}>
              <Calendar size={18} />
              <span>Featured Event</span>
            </button>
          </div>
          <div className="quick-menu-footer">
            <button onClick={() => handleNavigate('/admin')} className="full-dashboard-btn">
              Open Full Dashboard
            </button>
          </div>
        </div>
      )}

      {/* Floating edit button */}
      <button 
        className={`admin-edit-btn ${isOpen ? 'active' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        title="Edit Website Content"
      >
        {isOpen ? <X size={24} /> : <Settings size={24} />}
        <span className="btn-label">Edit</span>
      </button>
    </div>
  );
};

export default AdminEditButton;
